import { HtmlToPlainTextPipe } from '../../shared/pipes/html-to-plain-text.pipe';

export function htmlToPlainText ( htmlToPlainTextPipe : HtmlToPlainTextPipe ) {
  return ( text : string ) : string => htmlToPlainTextPipe.transform(text);
}
